<template>
    <v-dialog v-model="dialog" max-width="705" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>
            <h2 class="text-center">{{homework.title}}</h2>
            <p class="font-weight-bold mt-10" v-html="homework.description"></p>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['homework_id'],
        data(){
            return {
                dialog: false,
                homework: {},
            }
        },

        watch: {
            homework_id: function (newVal) {
                if(newVal)
                    this.$apiAdmin('homework').show(this.homework_id).then(res => {
                        this.homework = res.data.homework;
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/show";
</style>